/**
 * Servicio de leads — escribe en Realtime Database, nodo `/leads`.
 *
 * En producción endurecer: rate limiting con App Check, validación por campo
 * (ver `database.rules.json`), y App Check con reCAPTCHA Enterprise.
 */
import { ref, push, serverTimestamp } from 'firebase/database';

import type { LeadInput } from '../types/domain';

import { db } from './firebaseConfig';

export async function createLead(lead: LeadInput): Promise<string | null> {
  const payload = {
    ...lead,
    createdAt: serverTimestamp(),
    source: 'landing-web' as const,
    userAgent: typeof navigator !== 'undefined' ? navigator.userAgent : null,
  };
  const leadsRef = ref(db, '/leads');
  const result = await push(leadsRef, payload);
  return result.key;
}
